
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
      AsyncResult,
      callActionOrExecute,
      DataServiceQuery,
      IContext,
      IDataServiceRequest,
      // @ts-ignore -- Unused import
      IQueryResultSettings,
      // @ts-ignore -- Unused import
      NullResult
  } from '@msdyn365-commerce/retail-proxy';
  // @ts-ignore -- Unused import
  import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
  // @ts-ignore -- Unused import
  import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
  import * as DataServiceEntities from './DataServiceEntities.g';

  
  function checkGuaranteedItemQuery(): DataServiceQuery {
        return new DataServiceQuery();
        }

  
  export function checkGuaranteedItemInput (
      productRecordId:
          number
  ): IDataServiceRequest {
    const query = checkGuaranteedItemQuery();
    return query.createDataServiceRequestForOperation(
        'CheckGuaranteedItem',
        false, 
          DataServiceEntities.GuaranteedItemResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGuaranteedItemResponse' },
        {
        productRecordId: productRecordId
        }
    );
  }

  export function checkGuaranteedItemAsync (
      context: IContext, productRecordId:
          number
      ): AsyncResult<DataServiceEntities.IGuaranteedItemResponse> {
      const request = checkGuaranteedItemInput(productRecordId);
      return callActionOrExecute<DataServiceEntities.IGuaranteedItemResponse>(request, context.callerContext);
      }
    
  function getMultiUnitOfMeasureConversionQuery(): DataServiceQuery {
        return new DataServiceQuery();
        }

  
  export function getMultiUnitOfMeasureConversionInput (
      itemRecordIds:
          number[]
  ): IDataServiceRequest {
    const query = getMultiUnitOfMeasureConversionQuery();
    return query.createDataServiceRequestForOperation(
        'GetMultiUnitOfMeasureConversion',
        true, 
          DataServiceEntities.GetMultiUnitOfMeasureConversionResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetMultiUnitOfMeasureConversionResponse' },
        {
        itemRecordIds: itemRecordIds
        }
    );
  }

  export function getMultiUnitOfMeasureConversionAsync (
      context: IContext, itemRecordIds:
          number[]
      ): AsyncResult<DataServiceEntities.IGetMultiUnitOfMeasureConversionResponse> {
      const request = getMultiUnitOfMeasureConversionInput(itemRecordIds);
      return callActionOrExecute<DataServiceEntities.IGetMultiUnitOfMeasureConversionResponse>(request, context.callerContext);
      }
    
  function getSingleUnitOfMeasureConversionQuery(): DataServiceQuery {
        return new DataServiceQuery();
        }

  
  export function getSingleUnitOfMeasureConversionInput (
      productRecordId:
          number
  ): IDataServiceRequest {
    const query = getSingleUnitOfMeasureConversionQuery();
    return query.createDataServiceRequestForOperation(
        'GetSingleUnitOfMeasureConversion',
        false, 
          DataServiceEntities.GetSingleUnitOfMeasureConversionResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetSingleUnitOfMeasureConversionResponse' },
        {
        productRecordId: productRecordId
        }
    );
  }

  export function getSingleUnitOfMeasureConversionAsync (
      context: IContext, productRecordId:
          number
      ): AsyncResult<DataServiceEntities.IGetSingleUnitOfMeasureConversionResponse> {
      const request = getSingleUnitOfMeasureConversionInput(productRecordId);
      return callActionOrExecute<DataServiceEntities.IGetSingleUnitOfMeasureConversionResponse>(request, context.callerContext);
      }
    
  function getStockStatusQuery(): DataServiceQuery {
        return new DataServiceQuery();
        }

  
  export function getStockStatusInput (
      itemRecId:
          number
  ): IDataServiceRequest {
    const query = getStockStatusQuery();
    return query.createDataServiceRequestForOperation(
        'GetStockStatus',
        false, 
          DataServiceEntities.GetStockStatusResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetStockStatusResponse' },
        {
        itemRecId: itemRecId
        }
    );
  }

  export function getStockStatusAsync (
      context: IContext, itemRecId:
          number
      ): AsyncResult<DataServiceEntities.IGetStockStatusResponse> {
      const request = getStockStatusInput(itemRecId);
      return callActionOrExecute<DataServiceEntities.IGetStockStatusResponse>(request, context.callerContext);
      }
    
  function getCustomerWarehousesQuery(): DataServiceQuery {
        return new DataServiceQuery();
        }

  
  export function getCustomerWarehousesInput (
      customerId:
          string
  ): IDataServiceRequest {
    const query = getCustomerWarehousesQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustomerWarehouses',
        false, 
          DataServiceEntities.GetCustomerWarehousesResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetCustomerWarehousesResponse' },
        {
        customerId: customerId
        }
    );
  }

  export function getCustomerWarehousesAsync (
      context: IContext, customerId:
          string
      ): AsyncResult<DataServiceEntities.IGetCustomerWarehousesResponse> {
      const request = getCustomerWarehousesInput(customerId);
      return callActionOrExecute<DataServiceEntities.IGetCustomerWarehousesResponse>(request, context.callerContext);
      }
    
  function getStockHoldStatusQuery(): DataServiceQuery {
        return new DataServiceQuery();
        }

  
  export function getStockHoldStatusInput (
      customerId:
          string,
          itemId:
          string
  ): IDataServiceRequest {
    const query = getStockHoldStatusQuery();
    return query.createDataServiceRequestForOperation(
        'GetStockHoldStatus',
        false, 
          DataServiceEntities.GetStockHoldStatusResponseExtensionClass
        ,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetStockHoldStatusResponse' },
        {
        customerId: customerId,
          itemId: itemId
        }
    );
  }

  export function getStockHoldStatusAsync (
      context: IContext, customerId:
          string,
          itemId:
          string
      ): AsyncResult<DataServiceEntities.IGetStockHoldStatusResponse> {
      const request = getStockHoldStatusInput(customerId, itemId);
      return callActionOrExecute<DataServiceEntities.IGetStockHoldStatusResponse>(request, context.callerContext);
      }
    